import { UserFindDto, type UserFindInterface } from '@zaoblako/shared/modules/security/dtos/user/user-find.dto';
import { EavAttributeFindDto, type EavAttributeFindInterface } from '@zaoblako/shared/modules/eav/dtos/attribute/eav-attribute-find.dto';
import { SerdeDtoClass } from '@zaoblako/shared/modules/serde/classes/serde-dto.class';
import { EavDtoKeysEnum } from '@zaoblako/shared/modules/eav/enums/eav-dto-keys.enum';

import * as yup from 'yup';

/** EAV entity type response body - DTO signature */
export interface EavEntityTypeFindInterface {
  /** Unique ID */
  id: number;

  // Tech columns
  /** Creation date and time */
  created: Date;
  /** Last update date and time */
  updated: Date;
  /** Soft deletion update date and time. The EAV entity type will be permanently deleted six months after this date. */
  deleted?: Date;
  /** User who created this EAV entity type */
  createdBy?: UserFindInterface;

  // Data column
  /** EAV entity type display name */
  name: string;
  /** Attributes belongs to this entity type */
  attributes: EavAttributeFindInterface[];
}

/** EAV entity type response body - DTO schema */
export const EavEntityTypeFindDto = SerdeDtoClass.create<EavEntityTypeFindInterface>(EavDtoKeysEnum.EAV_ENTITY_TYPE_FIND_DTO, {
  id: {
    sortable: true,
    label: 'Номер',
    serializer: yup.number(),
  },
  created: {
    sortable: true,
    label: 'Создан',
    serializer: yup.date(),
  },
  updated: {
    sortable: true,
    label: 'Изменен',
    serializer: yup.date(),
  },
  deleted: {
    optional: true,
    label: 'Удален',
    serializer: yup.date(),
  },
  createdBy: {
    sortable: true,
    optional: true,
    label: 'Автор',
    nested: UserFindDto,
    serializer: (_, nested) => nested,
  },
  name: {
    sortable: true,
    label: 'Название',
    serializer: yup.string(),
  },
  attributes: {
    optional: true,
    label: 'Поля',
    nested: EavAttributeFindDto,
    serializer: (_, nested) => yup.array(nested),
  },
});
